;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('SavedRepliesController', SavedRepliesController)

  /* @ngInject */
  function SavedRepliesController ($scope, $rootScope, $q, $element, $compile, SavedRepliesService, ModalService) {
    const getManageSavedRepliesDialogController = () => $q.when(import('../../dialogs/manage-saved-replies/manage-saved-replies-dialog.controller'))
    let oldModalReference

    const api = {
      getManageSavedRepliesDialogController,
      _openReplyModal,
      _createSavedRepliesDropdown,
      _reloadSavedReplies
    }
    this.getApi = () => api

    activate()

    function activate () {
      api._createSavedRepliesDropdown()
    }

    $scope.truncateText = function (text, size) {
      if (!text) {
        return ''
      }
      size = size || 42
      let removedHTML = text.replace(/(<([^>]+)>)/ig, '')
      if (removedHTML.length > size) {
        removedHTML = removedHTML.substring(0, size) + '...'
      }
      return removedHTML
    }

    $scope.insertSavedReply = function (savedReply) {
      $element[0].editor.insertHTML(savedReply.text)
    }

    $scope.editSavedReply = function (savedReply) {
      api._openReplyModal(savedReply)
    }

    $scope.createSavedReply = function () {
      api._openReplyModal()
    }

    function _openReplyModal (savedReply) {
      oldModalReference = ModalService.getCurrentModal()

      api.getManageSavedRepliesDialogController().then(({ ManageSavedRepliesDialogController }) => {
        ModalService.showModal({
          templateId: 'manageSavedReplies.html',
          templateUrl: '/core/dialogs/manage-saved-replies/manage-saved-replies-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          controller: ManageSavedRepliesDialogController,
          appendElement: $($scope.trixBlockButtons).closest('.modal'),
          allowMultiple: true,
          data: {
            savedReply
          }
        }).then(() => {
          api._reloadSavedReplies()
          if (oldModalReference) {
            ModalService.setCurrentModal(oldModalReference)
          }
        })
      })
    }

    function _createSavedRepliesDropdown () {
      if (!$rootScope.isUserSysAdminAdminDesigner()) {
        return
      }

      SavedRepliesService.getCompanySavedReplies().then(savedReplies => {
        $scope.savedReplies = savedReplies
        $scope.trixBlockButtons = jQuery($element).parent().find('.trix-button-group--block-tools')
        const buttonHTML = `
            <div class="ui floating dropdown bottom right pointing trix-button trix-button--icon saved-replies-dropdown" tabindex="-1" style="border-bottom-width: 0;" data-trix-action="''">
              <div class="menu" style="right: 0;left: auto;">
                <div class="ui icon search input">
                  <i class="search icon"></i>
                  <input type="text" placeholder="{{ 'searchSavedReplies' | translate }}...">
                </div>
                <div class="header">
                  <i class="add icon"></i>
                  <a id="create-saved-reply-btn" class="create-saved-reply-btn" href="#" ng-click="createSavedReply();$event.preventDefault();">{{ 'newSavedReply' | translate }}</a>
                </div>
                <div class="divider" ng-show="savedReplies.length"></div>
                <div class="header" ng-show="savedReplies.length">
                  <i class="reply all icon"></i>
                  {{ 'savedReplies' | translate }}
                </div>
                <div class="scrolling menu">
                  <div class="item hidden" ng-if="!savedReplies.length"></div>
                  <div class="item" ng-repeat="reply in savedReplies" ng-model="reply" ng-click="insertSavedReply(reply)">
                    <i class="edit-saved-reply cog icon" ng-click="editSavedReply(reply);$event.stopPropagation();"></i>
                    <p class="saved-reply-title" >{{truncateText(reply.title)}}</p>
                    <div style="color:gray; font-size: 0.9em;">{{truncateText(reply.text, 50)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>`

        const element = $compile(buttonHTML)($scope)
        jQuery($scope.trixBlockButtons).append(element)
        jQuery($scope.trixBlockButtons).find('.trix-button--icon-increase-nesting-level, .trix-button--icon-decrease-nesting-level').addClass('hidden')

        if (!$rootScope.isDesktop) {
          jQuery($scope.trixBlockButtons).find('.trix-button--icon-code, .trix-button--icon-quote').addClass('hidden')
        }

        jQuery($scope.trixBlockButtons).find('.floating.dropdown').dropdown({
          fullTextSearch: 'exact',
          showOnFocus: false,
          onShow: () => {
            jQuery($scope.trixBlockButtons).find('.floating.dropdown').closest('trix-toolbar').css({ visibility: 'visible', height: 'inherit' })
          },
          onHide: () => {
            jQuery($scope.trixBlockButtons).find('.floating.dropdown').closest('trix-toolbar').css({ visibility: '', height: '' })
          }
        })
      })
    }

    function _reloadSavedReplies () {
      return SavedRepliesService.getCompanySavedReplies().then(savedReplies => {
        $scope.savedReplies = savedReplies
      })
    }
  }
})()
